import {all} from 'redux-saga/effects';
import {loginWatcherSaga} from './reducers/login.reducer';
import {contentWatcherSaga} from '../core/reducers/content.reducer';
import {fetchLexDetailWatcherSaga} from '../lex/store/sagas/index';
import {authWatcherSaga} from './sagas/auth.saga';

export default function* rootSaga() {
    yield all([
        loginWatcherSaga(),
        contentWatcherSaga(),
        fetchLexDetailWatcherSaga(),
        authWatcherSaga()
    ]);
}
